import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
      dark: '#5c9cfc',
      light: '#b3d4fc',
    },
    secondary: {
      main: '#f48fb1',
    },
    success: {
      main: '#4caf50',
      dark: '#2e7d32',
    },
    warning: {
      main: '#ff9800',
      dark: '#f57c00',
    },
    background: {
      default: '#0a0a0a',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0bec5',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '1.8rem', fontWeight: 700 },
    h2: { fontSize: '1.6rem', fontWeight: 600 },
    h3: { fontSize: '1.4rem', fontWeight: 600 },
    h4: { fontSize: '1.2rem', fontWeight: 600 },
    h5: { fontSize: '1.0rem', fontWeight: 600 },
    h6: { fontSize: '0.9rem', fontWeight: 600 },
    body1: { fontSize: '0.85rem' },
    body2: { fontSize: '0.75rem' },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 20px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundImage: 'none',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(30, 30, 30, 0.85)',
          backdropFilter: 'blur(10px)',
          boxShadow: 'none',
          borderRadius: 0,
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none',
          borderRadius: 0,
          backgroundColor: '#1e1e1e',
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            '& fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.23)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(144, 202, 249, 0.5)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#90caf9',
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-colorSuccess': {
            backgroundColor: 'rgba(76, 175, 80, 0.2)',
            color: '#4caf50',
            border: '1px solid rgba(76, 175, 80, 0.3)',
          },
          '&.MuiChip-colorWarning': {
            backgroundColor: 'rgba(255, 152, 0, 0.2)',
            color: '#ff9800',
            border: '1px solid rgba(255, 152, 0, 0.3)',
          },
        },
      },
    },
  },
});

export default theme; 